import { Loader, Select } from "@mantine/core"
import React from "react"
import { useActions, useAppState } from "src/state"
import { User_Status_Enum } from "src/state/gql/_types"
import { GenericFieldProps } from "src/utils/forms"
import { capitalizeWords } from "src/utils/string"

export const SupervisorAuditorSelect: React.FC<GenericFieldProps> = ({ id, name, label, onChange, onBlur, value, error, required, description, disabled, classNames }) => {

    const { itemsList, loading } = useAppState(state => state.users)
    const  getItems = useActions().users.getItems

    React.useEffect(() => {

        let controller: AbortController | null = new AbortController();

        const loadItems = async () => {

            if (controller) {
                try {
                    await getItems({
                        where: { 
                            status: {
                                _eq: User_Status_Enum.Active
                            }
                        }
                    })
                    controller = null;
                } catch (e: any) {
                    if (e.name !== 'AbortError') {
                        console.error(e)
                    }
                }
            }

        }
        
        loadItems()

        return () => controller?.abort()

    }, [getItems])

    if (!!!itemsList.length) error = 'No Active Users'
    
    return (
        <Select
            label={label}
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={error}
            required={required}
            disabled={disabled}
            description={description}
            rightSection={loading ? <Loader size="xs" /> : null}
            placeholder="Select..."
            searchable
            clearable
            data={itemsList.map(i=>({
                label: capitalizeWords(`${i.first_name} ${i.last_name} (${i.email})`),
                value: i.id
            }))}
            autoComplete="off"
            classNames={classNames}
        />
    )

}